import { Dialog, ImagePreview, Toast } from 'vant'

export const MAIN_TAB_ROUTES = ['/', '/record', '/homeMemory', '/memorandum', '/other']

export const SUB_ROUTE_TITLES = {
  '/statistics': '干饭数据查询',
  '/foodMenu': '菜谱',
  '/recipes': '今天吃啥',
  '/english': '英语',
  '/miaotixing': '喵提醒设置',
  '/baking': '烘培',
  '/sport': '记录运动',
  '/sleep': '睡眠',
  '/charge': '充电',
  '/IpList': 'IP 列表',
  '/deviceKey': '设备密钥',
  '/accountVault': '账号密码',
  '/loseWeight': '减肥大计',
}

const customHandlers = []

const EXIT_CONFIRM_MS = 2000

let isPopstate = false
let isProgrammaticBack = false
let lastExitBackAt = 0

function isUniAppWebView() {
  try {
    if (window.plus) return true
    if (window.uni && (window.uni.webView || window.uni.postMessage)) return true
    return /Html5Plus/i.test(navigator.userAgent)
  } catch (e) {
    return false
  }
}

function getUniBridge() {
  if (window.uni && window.uni.webView) {
    return window.uni.webView
  }
  return window.uni
}

export function isMainTab(path) {
  return MAIN_TAB_ROUTES.includes(path)
}

export function registerBackHandler(handler) {
  customHandlers.push(handler)
  return () => {
    const index = customHandlers.indexOf(handler)
    if (index >= 0) {
      customHandlers.splice(index, 1)
    }
  }
}

function runCustomHandlers() {
  for (let i = customHandlers.length - 1; i >= 0; i--) {
    if (customHandlers[i]() === true) {
      return true
    }
  }
  return false
}

function isVisible(el) {
  if (!el) return false
  const style = window.getComputedStyle(el)
  if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
    return false
  }
  const rect = el.getBoundingClientRect()
  return rect.width > 0 && rect.height > 0
}

function getVisibleElements(selector) {
  return Array.from(document.querySelectorAll(selector)).filter(isVisible)
}

function clickElement(el) {
  if (!el) return false
  el.click()
  return true
}

function closeTopOverlay() {
  const overlays = getVisibleElements('.van-overlay')
  if (overlays.length === 0) return false
  return clickElement(overlays[overlays.length - 1])
}

function dispatchEscape() {
  document.dispatchEvent(new KeyboardEvent('keydown', {
    key: 'Escape',
    code: 'Escape',
    keyCode: 27,
    which: 27,
    bubbles: true,
  }))
}

function closeTopDialog() {
  const dialogs = getVisibleElements('.van-dialog')
  if (dialogs.length === 0) return false

  const dialog = dialogs[dialogs.length - 1]
  const cancelBtn = dialog.querySelector('.van-dialog__cancel')
  if (cancelBtn) {
    return clickElement(cancelBtn)
  }

  const closeIcon = dialog.querySelector('.van-dialog__close, .van-icon-cross, .van-popup__close-icon')
  if (closeIcon) {
    return clickElement(closeIcon)
  }

  if (closeTopOverlay()) return true

  dispatchEscape()
  return isVisible(dialog)
}

function closeTopPopup() {
  const popups = getVisibleElements('.van-popup')
  if (popups.length === 0) return false

  const popup = popups[popups.length - 1]
  const closeIcon = popup.querySelector('.van-popup__close-icon, .van-icon-cross')
  if (closeIcon) {
    return clickElement(closeIcon)
  }

  return closeTopOverlay()
}

function closeDropdowns() {
  const activeItems = getVisibleElements('.van-dropdown-item--down')
  if (activeItems.length === 0) return false

  const openBar = document.querySelector('.van-dropdown-menu__bar')
  if (openBar) {
    const activeTitle = openBar.querySelector('.van-dropdown-menu__title--active')
    if (activeTitle) {
      return clickElement(activeTitle)
    }
  }

  return closeTopOverlay()
}

export function closeOverlays() {
  if (document.querySelector('.van-image-preview')) {
    ImagePreview.close()
    return true
  }

  Dialog.close()

  if (closeTopDialog()) return true
  if (closeTopPopup()) return true
  if (closeDropdowns()) return true
  if (closeTopOverlay()) return true

  return false
}

function resetExitBackTimer() {
  lastExitBackAt = 0
}

function tryExitApp() {
  const now = Date.now()
  if (lastExitBackAt && now - lastExitBackAt < EXIT_CONFIRM_MS) {
    resetExitBackTimer()
    notifyUniAppExit()
    return false
  }

  lastExitBackAt = now
  Toast('再按一次退出应用')
  return true
}

function notifyUniAppExit() {
  try {
    const runtime = window.plus && window.plus.runtime
    if (runtime && runtime.quit) {
      runtime.quit()
      return
    }
  } catch (e) {
    // ignore
  }

  try {
    const bridge = getUniBridge()
    if (bridge && bridge.postMessage) {
      bridge.postMessage({ data: { action: 'exitApp' } })
    }
  } catch (e) {
    // ignore when not in uni-app web-view
  }
}

function getHashPath() {
  const hash = window.location.hash.slice(1) || '/'
  return hash.split('?')[0] || '/'
}

function syncRouterFromHash(router) {
  const target = getHashPath()
  if (router.currentRoute.path !== target) {
    router.replace(target).catch(() => {})
  }
}

function keepCurrentHistoryEntry() {
  window.history.pushState({ spa: true }, '', location.href)
}

export function handleAppBack(router) {
  if (closeOverlays()) {
    return true
  }

  if (runCustomHandlers()) {
    return true
  }

  const path = router.currentRoute.path

  if (!isMainTab(path)) {
    isProgrammaticBack = true
    router.replace('/other')
    return true
  }

  if (isUniAppWebView()) {
    return tryExitApp()
  }

  if (window.history.length > 1) {
    isProgrammaticBack = true
    router.back()
    return true
  }

  notifyUniAppExit()
  return false
}

export function installBackNavigation(router) {
  if (isUniAppWebView()) {
    window.history.pushState({ spa: true }, '', location.href)
  }

  router.afterEach(() => {
    resetExitBackTimer()

    if (isPopstate) {
      isPopstate = false
      return
    }

    if (isProgrammaticBack) {
      isProgrammaticBack = false
      if (isUniAppWebView()) {
        window.history.replaceState({ spa: true }, '', location.href)
      }
      return
    }

    if (isUniAppWebView()) {
      window.history.pushState({ spa: true }, '', location.href)
    }
  })

  window.addEventListener('popstate', () => {
    if (closeOverlays()) {
      keepCurrentHistoryEntry()
      return
    }

    isPopstate = true
    syncRouterFromHash(router)
  })

  window.__handleBackPress = function handleBackPress() {
    return handleAppBack(router)
  }
}
